require("turbolinks").start()
require('jquery')
import $ from "jquery";

import './stylesheets/about_page.scss';
import './stylesheets/form.scss';
require.context('./images', true, /\.(png|jpg|jpeg|svg|webp|gif)$/);

// LP のサインアップフォーム (pages/_signup) で利用規約チェックの制御に使う
// @see https://github.com/exestinc/video_db/issues/2397
import './javascripts/shared/checkboxControl';
// Turnstile のウィジェット描画 (キー未設定なら .js-turnstile が無いので何もしない)
import './javascripts/shared/turnstile';

// 画面ごとの初期化スクリプト (application pack と同じ仕組み。@see javascripts/shared/viewScript)
import runViewScripts from './javascripts/shared/viewScript';

import pageAbout from './javascripts/views/pages/about';
// merit ページはコンポーネントがほぼ同じなので JS も共通化している
import meritPage from './javascripts/views/merits/shared';

runViewScripts({
  'pages/about': pageAbout,
  'merits/premier': meritPage,
  'merits/request_to_edit': meritPage
});
